import _extends from "@babel/runtime/helpers/extends";
import React, { useImperativeHandle } from 'react';
import { useLabel } from './useLabel';
import { jsx as _jsx } from "react/jsx-runtime";
export * from './useLabel';
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    label,
    Portal
  } = useLabel(_extends({}, props));
  useImperativeHandle(ref, () => _extends({}, props, {
    label
  }), [label, props]);
  return /*#__PURE__*/_jsx(Portal, {
    children: props.children
  });
});